module.exports = __webpack_public_path__ + "img/T5-B-rc10.ab28cd49.png";